import Vuex from 'vuex'
import axios from 'axios'
import Vue from 'vue'

Vue.use(Vuex);


export default new Vuex.Store({
    install(Vue, options){
        function getCsrfToken(){
            const cookies = document.cookies.split(';');
            for(let i = 0; i < cookies.length; i++){
                const cookie = cookies[i].trim();
                if(cookie.startWith('XSRF-TOKEN')){
                    return cookie.substring('XSRF-TOKEN='.length, cookie.length);
                }
            }
            return null;
        }
        Vue.prototype.$addCsrfTokenToHeaders = function(headers){
            const csrfToken = getCsrfToken();
            if(csrfToken){
                headers['X-XSRF-TOKEN'] = csrfToken;
            }
            return headers;
        };

    },
    state: {
        idToken: sessionStorage.getItem('access_token') || null,
        lastActivityTime : sessionStorage.getItem('lastActivityTime')||null,
    },
    getters: {
        loggedIn(state) {
            return state.idToken != null;
        },
    },
    mutations: {
        RetriveToken(state, token) {
            state.idToken = token;
        },
        setLastActivityTime(state, time){
            state.lastActivityTime = time;
        },
        setCsrfToken(state, token){
            state.csrfToken = token;
        },
        logout(state) {
            state.idToken = null;
            state.lastActivityTime=null;
            sessionStorage.removeItem('access_token');
            sessionStorage.removeItem('refresh_token');
            sessionStorage.removeItem('user_role');
        },
    },
    actions: {
        RetriveToken(context, credentials) {
            axios.defaults.headers.common["X-CSRF-TOKEN"] = sessionStorage.getItem('csrf_token');
            //axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            axios.defaults.headers.common["X-CSRF-TOKEN"] = sessionStorage.getItem('csrf_token');
            // Add SameSite attribute to the CSRF token header
            axios.defaults.headers.common["Cookie"] = "csrf_token=" + sessionStorage.getItem('csrf_token') + "; SameSite=Strict";        
            delete axios.defaults.headers.common["Authorization"];
            return new Promise((resolve, reject) => {
                //console.log("creden",credentials);
                axios.post('/user/login', credentials)
                    .then(async (response) => {
                        console.log("login ",response.data);
                        if (response && response.data && response.data.token) {
                            // Store session data if the response is valid
                            sessionStorage.setItem("access_token", response.data.token.access);
                            sessionStorage.setItem("refresh_token", response.data.token.refresh);
                            sessionStorage.setItem("ID", response.data.user.ownedBy);
                            sessionStorage.setItem("superID", response.data.user.superUserId);
                            sessionStorage.setItem("userID", response.data.user.id);
                            sessionStorage.setItem("lastActivityTime", Date.now());
                            sessionStorage.setItem("user_role", response.data.user.role);
    
                            // Store modules data
                            let modules = "";
                            await response.data.modules.forEach((element, idx, array) => {
                                if (idx === array.length - 1) {
                                    if (element.listData === 1) {
                                        modules += element.name;
                                    }
                                } else {
                                    if (element.listData === 1) {
                                        modules += element.name + ",";
                                    }
                                }
                            });
                            sessionStorage.setItem("modules", modules);
                        } else {
                            // Handle case where token or user data is not in the response
                            console.error("No token or user data found in response.");
                            sessionStorage.setItem("ID", response.data.userId);
                        }
                        resolve(response);
                    })
                    .catch(error => {
                        console.error("API call failed:", error);
                        reject(error);
                    });
            });
        },
        async GetCsrfToken(context){
            return new Promise(async (resolve, reject) =>{
            await axios.get('/get/token', { refresh_token: sessionStorage.getItem('refresh_token')})
              .then(response => {
                // console.log('CSRF token received:', response.data.token);
                sessionStorage.setItem('csrf_token',  response.data.token,"SameSite=Strict");
                context.commit('RetriveToken', response.data.token);
                resolve(response);
              })
              .catch(error => {
                console.log(error);
                reject(error);
              })

            })

          },        
        logout(context) {
            return new Promise((resolve) => {
                context.commit('logout');
                sessionStorage.removeItem('access_token');
                sessionStorage.removeItem('refresh_token');
                sessionStorage.removeItem('user_role');
                resolve();
            });
        },
        async renewAccessToken(context) {
            return new Promise(async (resolve, reject) => {
                await axios.post('/user/token/refresh', { refresh_token: sessionStorage.getItem('refresh_token') })
                    .then(response => {
                        sessionStorage.setItem('access_token', response.data.access_token);
                        sessionStorage.setItem('refresh_token', response.data.refresh_token);
                        context.commit('RetriveToken', response.data.access_token);
                        resolve(response);
                    })
                    .catch(error => {
                        console.error("Failed to renew access token:", error);
                        reject(error);
                    });
            });
        },
        Logout({ commit }) {
            return new Promise((resolve, reject) => {
                commit('Logout');
                sessionStorage.removeItem('access_token');
                sessionStorage.removeItem('refresh_token');
                sessionStorage.removeItem('user_role');
                delete axios.defaults.headers.common['Authorization'];
                if (!sessionStorage.getItem('access_token')) resolve("successfully signed out");
                else reject("problem on destroying token");
            });
        },
        changePassword(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/user/change/password', user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        changePasswordAtLogin(context, user){
            delete axios.defaults.headers.common["Authorization"];
            // axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/user/change/password/not/token', user)
                .then(async response=>{
                    // console.log("change", response);
                    if(response.data.token){
                            sessionStorage.setItem("access_token", response.data.token.access);
                            sessionStorage.setItem("refresh_token", response.data.token.refresh);
                            sessionStorage.setItem("ID", response.data.user.ownedBy);
                            sessionStorage.setItem("superID", response.data.user.superUserId);
                            sessionStorage.setItem("userID", response.data.user.id);
                            // Set the user role
                            const userRole = response.data.user.role;
                            sessionStorage.setItem("user_role", userRole);
                            var modules = "";
                            await response.data.modules.forEach((element, idx, array) => {
                                if(idx === array.length - 1 ){
                                    if(element.listData == 1){
                                        modules += element.name;
                                    }
                                }else{
                                    if(element.listData == 1){
                                        modules += element.name + ",";
                                    }
                                }
                            });
                            sessionStorage.setItem("modules", modules)
                        }else{
                            sessionStorage.setItem("ID", response.data.userId);
                        }
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        resetPassword(context, user){
            return new Promise((resolve, reject) => {
                axios.post('/user/reset/password', user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getEkubsByOwnerID(context, userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/get/by/users', userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    //console.log("Error:", error)
                    reject(error.response);
                })
            })
        },
        getAllAssociation(context, userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/get/by/users/all', userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    //console.log("Error:", error)
                    reject(error.response);
                })
            })
        },
        getAllAssociationDashboard(context, userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/get/by/users/all/dashboard', userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    //console.log("Error:", error)
                    reject(error.response);
                })
            })
        },
        getAllAssociationForDrawingOfIndvidual(context, userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/get/ekub/type/of/individual', userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    //console.log("Error:", error)
                    reject(error.response);
                })
            })
        },
        filterDrawingUsingEkubTypeId(context, userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/linking/filter/by/ekub', userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    //console.log("Error:", error)
                    reject(error.response);
                })
            })
        },
        filterDrawingUsingForGroup(context, userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/get/ekub/type/of/group/all', userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    //console.log("Error:", error)
                    reject(error.response);
                })
            })
        },
        filterDrawingUsingForGroupForManual(context, userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/get/ekub/type/of/group/for/manualy', userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    //console.log("Error:", error)
                    reject(error.response);
                })
            })
        },
        callForWinningForIndividual(context, userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/draw/for/member/for/each/ekub/type', userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    //console.log("Error:", error)
                    reject(error.response);
                })
            })
        },
        callForWinningManualyForIndividual(context, userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/linking/get/all/members/for/drawing', userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    //console.log("Error:", error)
                    reject(error.response);
                })
            })
        },
        callForWinningForGroup(context, userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/draw/for/group/for/ekub/type', userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    //console.log("Error:", error)
                    reject(error.response);
                })
            })
        },
        AddEkub(context,Ekub){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/post', Ekub)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        AddAssociationForUser(context,Ekub){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/post/for/user', Ekub)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getCustomerByOwnerID(context,userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/joiner/get/by/users',userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getAllCountMemberForSuper(context,userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/joiner/get/all/member/super',userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getAllCountMemberForAdmin(context,userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/joiner/get/all/member',userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getAllCountAssociationForAdmin(context,userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/get/all/association',userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getAllCountAssociationForSuper(context,userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/get/all/association/super',userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getAllMembers(context,userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/joiner/get/all',userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        AddCustomer(context,EkubJoiner){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('ekub/joiner/post', EkubJoiner)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        AddMembersForSuperWithLinking(context,EkubJoiner){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('ekub/joiner/post/for/super/with/linking', EkubJoiner)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getEkubLinksByOwnerID(context,userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/linking/get/by/users/not/completed',userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getAllAssociationLinkageNotCompleted(context,userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/linking/get/all/not/completed',userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getEkubLinksByOwnerIDWhichIsCompleted(context,userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/linking/get/by/users/completed',userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getAllAssociationLinkageCompleted(context,userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/linking/get/all/completed',userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        CreateEkubLinkExistingEkubTypeEkubMember(context,Contract){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/linking/post/existing/ekub/existing/member', Contract)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        CreateEkubLinkingNotEkubMemberExistingEkubType(context,EkubLinking){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/linking/post/existing/ekub/not/member', EkubLinking)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        CreateEkubLinkingNotEkubMemberNotEkubType(context,EkubLinking){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/linking/post/existing/ekub/existing/member', EkubLinking)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        CreateEkubLinkingNotEkubTypeExistingEkubMember(context,EkubMember){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/linking/post/not/ekub/existing/member', EkubMember)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getPaymentsByOwnerID(context,userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/payment/get/user',userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getPayments(context,userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/payment/get/all',userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
       
        getPaidAmountAndList(context, userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/payment/check/calculate/paid/this/month',userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getPaidAmountAndListForSuper(context, userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/payment/check/calculate/paid/this/month/for/super',userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getUnPaidAmountAndList(context, userId){
            //console.log("here1", userId);
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/payment/check/calculate/unpaid/this/month',userId)
                .then(response=>{
                    //console.log("here", response);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getUnPaidAmountAndListForSuper(context, userId){
            //console.log("here1", userId);
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/payment/check/calculate/unpaid/this/month/for/super',userId)
                .then(response=>{
                    //console.log("here", response);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getMonthlyTotalIncome(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/payment/check/yearly/paid/for/each/month',user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getMonthlyTotalIncomeForSuper(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/payment/check/yearly/paid/for/each/month/for/super',user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        ChangePrice(context, price){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/housePrice',price)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        EditEkub(context, ekub){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/update', ekub)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        EditCustomer(context, customer){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/joiner/update', customer)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        AddBulkMember(context, customer){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/joiner/post/bulk/member', customer)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        AddBulkAssociationLinkage(context, customer){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/linking/post/bulk/data', customer)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        AddBulkAssociation(context, customer){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/post/bulk/association', customer)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        AddBulkAssociationForUser(context, customer){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/post/bulk/association/for/user', customer)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        EditAssocationLinkage(context, linkage){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/ekub/linking/update', linkage)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getAccountByID(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/user/get/by/id', user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        GetContractFile(context, file){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/contract/encode', file)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getPaymentsByOwnerIDAndDate(context, Date){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/payment/get/user/filter/by/date', Date)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getPaymentsByDate(context, Date){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/payment/get/all/filter/by/date', Date)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getPaymentsByOwnerIDAndDateAndEkub(context, Date){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/payment/get/user/filter/by/ekub/and/date', Date)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getPaymentsByAndDateAndEkub(context, Date){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/payment/get/all/filter/by/ekub/and/date', Date)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getPaymentsByOwnerIDAndEkub(context, Date){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/payment/get/user/filter/by/ekub', Date)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getPaymentsByEkub(context, Date){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/payment/get/all/filter/by/ekub', Date)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getModulesPermission(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/role/module/get/user/details', user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getUsersByOwnerID(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/user/admin/users', user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getUserBySuperAdminId(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/user/super/admin/users', user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getUserBySystemAdminId(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/user/system/admin/users', user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getUsersByOwnerID(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/user/admin/users', user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        AddUsers(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/user/register/other/for/admin', user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        AddUsersForSuper(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/user/register/other/for/super/admin', user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        AddUsersSUperUser(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/user/register', user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        AddUserSystemUser(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/user/register/system/admin', user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        AddUserSystemManager(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/user/register/system/manager', user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getModulesList(context){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.get('/role/module/module')
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        AddModuleAndPermission(context, module){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/user/add/module/specific/user', module)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        UpdateModuleAndPermission(context, module){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/user/update/module/permission', module)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        DeleteModuleandPermissionForUser(context, module){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/user/delete/module/permission', module)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        LockUser(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/user/lock/user', user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        UnlockUser(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/user/unlock/user', user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        UpdateUser(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/user/update/user', user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getReportByPhoneNumberForSuper(context, report){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/get/user/report/by/phone/for/super', report)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getReportByPhoneNumber(context, report){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/get/user/report/by/phone', report)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getReports(context, report){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/get/all/report', report)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getReportsForUser(context, report){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/get/user/report', report)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getReportsByPaymentStatus(context, report){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/get/all/report/filter/payment/status', report)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getReportsByPaymentStatusForUser(context, report){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/get/user/report/filter/payment/status', report)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getReportsByCompletionStatus(context, report){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/get/all/report/filter/completion/status', report)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getReportsByCompletionStatusForUser(context, report){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/get/user/report/filter/completion/status', report)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getReportsByCompletionStatusAndPaymentStatus(context, report){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/get/all/report/filter/completion/status/payment/status', report)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getReportsByCompletionStatusAndPaymentStatusForUser(context, report){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/get/user/report/filter/completion/status/payment/status', report)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getReportsByEkub(context, report){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/get/all/report/filter/by/ekub', report)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getReportsByEkubForUser(context, report){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/get/user/report/filter/by/ekub', report)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getReportsByPaymentStatusandEkub(context, report){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/get/all/report/filter/ekub/payment/status', report)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getReportsByPaymentStatusandEkubForUser(context, report){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/get/user/report/filter/ekub/payment/status', report)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getReportsByCompletionStatusandEkub(context, report){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/get/all/report/filter/completion/status/ekub', report)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getReportsByCompletionStatusandEkubForUser(context, report){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/get/user/report/filter/completion/status/ekub', report)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getReportsByCompletionStatusandPaymentStatusAndEkub(context, report){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/get/all/report/filter/completion/status/payment/status/ekub', report)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getReportsByCompletionStatusandPaymentStatusAndEkubForUser(context, report){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/get/user/report/filter/completion/status/payment/status/ekub', report)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
    getOverdueEkubUnpaidNotification(context, ID){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/payment/get/unpaid/list/notification', ID)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    getOverdueEkubUnpaidNotificationForUser(context, ID){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/payment/get/unpaid/list/notification/for/user', ID)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    getWinningListGroup(context, ID){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/ekub/get/winning/list/group', ID)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    getWinningListIndividual(context, ID){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/ekub/get/winning/list/individual', ID)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    calculateAmountCollectedByTsehay(context, ID){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/payment/calculate/collected/by/tsehay', ID)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    getPaymentsAllCollectedByTsehay(context, params){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/get/all/collected/by/tsehay', params)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    getPaymentsUnified(context, params){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/payment/get/all/in/one', params)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    calculateAmountCollectedByTsehayForAdmin(context, ID){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/payment/calculate/collected/by/tsehay/admin', ID)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    getReportsUnified(context, report){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/get/all/report/in/one', report)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    getReportsUnifiedForAdmin(context, report){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/get/all/report/in/one/for/admin', report)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    getAllAuditLogs(context, filter){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/audit/logs/list/all', filter)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                // keep consistent with other actions that return error.response
                reject(error.response || error);
            })
        })
    },
    getAllUsers(context){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.get('/user/get/all')
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error.response || error);
            })
        })
    },
    getPaymentsUnifiedForAdmin(context, params){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/payment/get/all/in/one/for/admin', params)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    getEkubByPhoneNumber(context, params){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/ekub/linking/getEkubByPhoneNumber', params)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    bulkUpdateManualPayments(context, updateRequests){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/ekub/linking/post/bulk/data/for/update/history', updateRequests)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    terminateEkubLinking(context, params){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/ekub/linking/terminate', params)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    }
    
}
})